
angular.module('bmsApp.crm.prospect').factory('ProspectSvc', function (CRUDSvc, PROSPECT_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(PROSPECT_API.INDEX, params);
		},
		byCustomer: function (customerId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					customer: customerId
				}
			});
			return CRUDSvc.get(PROSPECT_API.INDEX, newParams);
		},
		create: function (prospect) {
			return CRUDSvc.post(PROSPECT_API.CREATE, prospect);
		},
		read: function (id) {
			return CRUDSvc.get(PROSPECT_API.READ + id);
		},
		update: function (id, prospect) {
			return CRUDSvc.post(PROSPECT_API.UPDATE + id, prospect);
		},
		export: function(params) {
			var newParams = angular.extend({}, params, {
				'format': 'csv'
			});
			var query = $.param(newParams);
			window.open(PROSPECT_API.INDEX + '?' + query);
		}
	};

}).constant('PROSPECT_API', {
	INDEX: 'api/prospect/index',
	CREATE: 'api/prospect/create',
	READ: 'api/prospect/read/',
	UPDATE: 'api/prospect/update/'
});
